<template>
  <div class="IdRazdel">
    <div class="opIdPhone">телефон</div>
    <div class="IdPhone">{{ user.phone }}</div>
    <div class="opIdSite">сайт или страница</div>
    <div class="IdSite"><a :href="user.link">{{ user.link }}</a></div>
    <div class="opIdOpis">главное обо мне</div>
    <div class="IdOpis">{{ user.description }}</div>
    <div class="BtEditUserInfo" @click.prevent="$emit('hideAction')" v-if="showEditLink && user.id"></div>

    <!-- <div class="opIdFacilitator">фасилитатор</div>
    <div class="IdFacilitator">{{ true_false[user.facilitator] }}</div> -->
  </div>
</template>

<script>
import { TRUE_FALSE } from "@/utils/true_false";

export default {
  props: {
    user: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } }
  },
  data() {
    return {
      true_false: TRUE_FALSE,
    }
  }
};
</script>
